
import { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import { IoIosSave } from "react-icons/io";
import 'react-toastify/dist/ReactToastify.css';

import { toast } from 'react-toastify';


const DivGeral = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #fff;
  padding: 25px;
  box-shadow: 0px 0px 2px #ccc;
`;


const Label = styled.label`
  color: #4f4f4f;
  font-weight: bold;
  font-size: 17px;  
  display: flex;
  flex-direction: column;
`;






const Div = styled.div`
  display: flex;
  flex-direction:row;
  justify-content: center;
  gap: 1rem;
  margin-top: 1rem;

  select {
    width: 250px;
    padding: 0 10px;
    border: 1px solid #bbb;
    border-radius: 5px;
    height: 37px;
  }

`;


const Input1 = styled.input`

  width: 200px;
  padding: 0 10px; 
  border: 1px solid #bbb;
  border-radius: 5px;
  height: 37px;
  box-sizing: border-box; 
`;


const Input2 = styled.input`
  width: auto;
  min-width: 500px;
  padding: 0 10px; 
  border: 1px solid #bbb;
  border-radius: 5px;
  height: 37px;
  box-sizing: border-box; 
`;
const Input3 = styled.input`
  width: 70px;
  padding: 0 10px;
  border: 1px solid #bbb;
  border-radius: 5px;
  height: 37px;
  box-sizing: border-box; 
`;

const Input4 = styled.input`
  width: auto;
  min-width: 500px;
  height: 200px;
  padding: 0 10px; 
  border: 1px solid #bbb;
  border-radius: 5px;
  height: 37px;
  box-sizing: border-box; 
`;
const H2 = styled.h2`
  color: #575757;
`;

const Button = styled.button`
  padding: 10px 30px;
  background-color: transparent;
  color: #575757;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 22px;
  font-weight: bold;
  @media (max-width: 768px) {
    padding: 5px;
    font-size: 14px;
  }
  
`;


const Form = ({ urlApi, editarLancamentos, setAtualizaLancamentos }) => {



  //========================================================TOKEN
  const token = localStorage.getItem('token');
  const id = localStorage.getItem('id');


  useEffect(() => {
    if (editarLancamentos) {
      setCodigoMaterial(editarLancamentos.COD_MATERIAL.toString());

      setDescricaoMaterial({
        DESC_MATERIAL: editarLancamentos.DESCRICAO,
        UNIDADE_MEDIDA: editarLancamentos.UNIDADE_MEDIDA || ''
      });
      if (editarLancamentos.DATA_FORMATADA) {
        const [dia, mes, anoHora] = editarLancamentos.DATA_FORMATADA.split('/');
        const [ano, hora] = anoHora.split(' ');
        const dataISO = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`;
        setDataHora(dataISO);
      }

      setObservacao(editarLancamentos.OBSERVACAO || '');
      setQuantidade((editarLancamentos.QUANTIDADE_FORMATADA || '').trim());


      setSaldoCS(editarLancamentos.QUANTIDADE_ESTOQUE || '');

      setTipoSelecionado(mapTipoDescricaoParaValor[editarLancamentos.DESC_TIPO] || '');
      setSituacaoSelecionado(mapSituacaoDescricaoParaValor[editarLancamentos.DESC_SITUACAO] || '');
    }
  }, [editarLancamentos]);

  const [saldoCS, setSaldoCS] = useState('');


  //========================================================SELECT FILTRA O OUTRO
  const [tipoSelecionado, setTipoSelecionado] = useState(null);
  const [codigoMaterial, setCodigoMaterial] = useState('');
  const [dataHora, setDataHora] = useState();
  const [descricaoMaterial, setDescricaoMaterial] = useState('');

  const [quantidade, setQuantidade] = useState('');
  const [situacaoSelecionado, setSituacaoSelecionado] = useState(null);

  // const mapTipoDescricaoParaValor = {
  //   "Entrada": "E",
  //   "Saída": "S",
  //   "Ajuste de Estoque": "A",
  //   "Perda / Quebra": "P",
  //   "Devolução": "D"
  // };

  const mapTipoDescricaoParaValor = {
    "Entrada": "E",
    "Saída": "S",
  };

  const mapSituacaoDescricaoParaValor = {
    "Aguardando Baixa": "AB",
    "Baixado": "BA"
  };





  //========================================================ADICIONAR O MATERIAL NO LB_MATERIAL
  const [observacao, setObservacao] = useState('');
  const [saldoAnterior, setSaldoAnterior] = useState('');

  const handleEditaMaterial = async () => {
    if (observacao && observacao.length > 250) {
      toast.warn('A observação não pode ter mais de 250 caracteres.');
      return;
    }

    const precoUnitario = parseFloat(editarLancamentos.VALOR_UNITARIO) || 0;
    const total = precoUnitario * qtd;
    const quantidadeConvertida = parseFloat(quantidade.replace(/\./g, '').replace(',', '.'));

    try {
      const payload = {
        quantidade: quantidadeConvertida,
        tipo: tipoSelecionado,
        observacao: observacao?.trim() || null,
        situacao: situacaoSelecionado,
        valor_total: total,
        saldo_anterior: Number(saldoAnterior),
        cod_funcionario_alterou: id,
      };


      const res = await axios.put(
        `${urlApi}controle-reagentes/alterar-lancamento`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            cod_material: codigoMaterial.trim(),
            data: editarLancamentos.DATA_FORMATADA

          }
        }
      );


      toast.success(res.data.message || 'Lançamento atualizado com sucesso!');
      setAtualizaLancamentos(true);
    } catch (err) {
      console.error('Erro ao atualizar o lançamento:', err);
      toast.error(err.response?.data?.error || 'Erro ao atualizar lançamento.');
    }
  };



  //-------------------------------------VALOR TOTAL--------------------------------------------//
  const precoUnitario = Number(editarLancamentos.VALOR_UNITARIO) || 0;
  const qtd = parseFloat(quantidade) || 0;
  const total = precoUnitario * qtd;

  const totalFormatado = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(total);


  return (
    <DivGeral>
      <H2>Editar Lançamento Material</H2>


      <Div>
        <Label>
          Data:
          <Input1
            type="date"
            value={dataHora}
            onChange={(e) => setDataHora(e.target.value)}
            required
            disabled
          />
        </Label>
        <Label>
          Código do Material:
          <Input1
            type="text"
            value={codigoMaterial}
            onChange={(e) => setCodigoMaterial(e.target.value)}
            disabled
            placeholder="Digite o código"
          />

        </Label>

        {/* Exibe a descrição do material */}
        <Label>
          Descrição:
          <Input2
            type="text"
            value={`${descricaoMaterial.DESC_MATERIAL || ''} `}
            disabled
          />

        </Label>
        <Label>
          Uni:
          <Input3
            type="text"
            value={` ${descricaoMaterial.UNIDADE_MEDIDA || ''}`}
            disabled

          />

        </Label>
      </Div>
      <Div>
        <Label>
          Quantidade:
          <Input1
            type="text"
            value={quantidade}
            onChange={(e) => setQuantidade(e.target.value)}
            placeholder="Digite a quantidade"
          />


        </Label>

        {/*<Label>
          Tipo:
          <select
            value={tipoSelecionado || ''}
            onChange={(e) => setTipoSelecionado(e.target.value)}
          >
            <option value="" disabled>Selecione o tipo</option>
            <option value="E">Entrada</option>
            <option value="S">Saída</option>
            <option value="A">Ajuste de Estoque</option>
            <option value="P">Perda / Quebra</option>
            <option value="D">Devolução</option>
          </select>
        </Label>*/}

        <Label>
          Tipo:
          <select
            value={tipoSelecionado || ''}
            onChange={(e) => setTipoSelecionado(e.target.value)}
            disabled
          >
            <option value="" disabled>Selecione o tipo</option>
            <option value="E">Entrada</option>
            <option value="S">Saída</option>
          </select>
        </Label>






        <Label>
          Observação:
          <Input4
            type="text"
            value={observacao}
            onChange={(e) => setObservacao(e.target.value)}
            disabled={!codigoMaterial}
            placeholder="Digite uma observação"
          />


        </Label>
      </Div>
      <Div>
        <Label>
          Saldo no Sistema:
          <Input1
            type="text"
            value={editarLancamentos.SALDO_ATUAL != null ? editarLancamentos.SALDO_ATUAL : '0'}
            onChange={(e) => setSaldoAnterior(e.target.value)}
            disabled
            readOnly
          />

        </Label>

        {/*<Label>
          Saldo na CS:
          <Input1
            type="text"
            value={editarLancamentos.QUANTIDADE_ESTOQUE != null ? editarLancamentos.QUANTIDADE_ESTOQUE : '0'}
            disabled
            readOnly
          />

        </Label>*/}
        <Label>
          Valor unitário:
          <Input1
            type="text"
            value={
              editarLancamentos.VALOR_UNITARIO
                ? new Intl.NumberFormat('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                }).format(editarLancamentos.VALOR_UNITARIO)
                : ''
            }
            disabled
            readOnly
          />
        </Label>
        <Label>
          Valor total:
          <Input1
            type="text"
            value={codigoMaterial ? totalFormatado : ''}
            disabled
            readOnly
          />
        </Label>


        <Label>
          Situação:
          <select
            value={situacaoSelecionado || ''}
            onChange={(e) => setSituacaoSelecionado(e.target.value)}
          >
            <option value="" disabled>Selecione a situação</option>
            <option value="AB">Aguardando baixa</option>
            <option value="BA">Baixado</option>
          </select>
        </Label>

      </Div>
      <Div>
        <Label>
          Responsável pelo lançamento:
          <Input4
            type="text"
            value={` ${editarLancamentos.COD_FUNCIONARIO_LANCOU || ''} - ${editarLancamentos.NOME_FUNCIONARIO_LANCOU || ''}`}
            disabled
          />


        </Label>
      </Div>
      <Div>
        <Label>
          Responsável pela última alteração:
          <Input4
            type="text"
            value={` ${editarLancamentos.COD_FUNCIONARIO_ALTEROU || ''} - ${editarLancamentos.NOME_FUNCIONARIO_ALTEROU || ''}`}
            disabled
          />


        </Label>
      </Div>
      <Div>
        <Button
          disabled={!codigoMaterial || !tipoSelecionado}
          onClick={handleEditaMaterial}
        >
          <IoIosSave color={"green"} />Salvar Alteração
        </Button>
      </Div>

      <style jsx global>{`
        .swal2-container.custom-swal-container {
          z-index: 9999;
        }
      `}</style>
    </DivGeral>
  );
};

export default Form;




